import { Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UpdateSurveyState } from "../Store";
import { deleteSurvey } from "../Store/Thunk";
import {
  AdminListCard,
  AdminListMain,
  AdminActions,
  AdminButton,
  ConfirmDeleteButton,
} from "../../../SharedComponents/ListView";

export default function SurveyList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const surveyList = useSelector((state) => state.survey.surveyList);

  const HandleUpdateButton = (survey) => {
    dispatch(UpdateSurveyState({ id: survey.id, name: survey.name, isUpdateOperation: true }));
  };

  return (
    surveyList &&
    surveyList.map((survey, i) => (
      <AdminListCard
        key={"survey" + i}
        tag={survey.tag}
        footer={
          survey.assessments?.length
            ? survey.assessments.map((assessment, m) => (
                <Badge key={"te" + m} bg={assessment.isB2b ? "success" : "secondary"}>
                  {assessment.name}
                </Badge>
              ))
            : null
        }
      >
        <AdminListMain>
          <span className="admin-list-id">{survey.id}</span>
          <span className="admin-list-title">{survey.name}</span>
        </AdminListMain>
        <AdminActions>
          <AdminButton variant="outline" onClick={() => HandleUpdateButton(survey)}>
            {t("edit")}
          </AdminButton>
          <ConfirmDeleteButton onConfirm={() => dispatch(deleteSurvey({ id: survey.id }))} />
        </AdminActions>
      </AdminListCard>
    ))
  );
}
